export class CreateQuoteMessage {
  buildTypeId: number
  cartridgeId?: number
  customerId: number
  customerSuppliedParts: string
  partsDiscountPercentage: number
  servicesDiscountPercentage: number
  
  constructor(buildTypeId: number, cartridgeId: number|undefined, customerId: number, customerSuppliedParts: string, partsDiscountPercentage: number, servicesDiscountPercentage: number) {
    this.buildTypeId = buildTypeId
    this.cartridgeId = cartridgeId
    this.customerId = customerId
    this.customerSuppliedParts = customerSuppliedParts
    this.partsDiscountPercentage = partsDiscountPercentage
    this.servicesDiscountPercentage = servicesDiscountPercentage
  }
}
    